/**
 * The `ConversationShell` body's state decision, extracted so the P6 item-2
 * invariant is PINNABLE without a DOM: an empty thread WITHOUT `readError`
 * ("no history") and an empty thread WITH it ("we could not look") MUST map
 * to different render states. Conflating them shows a lawyer an empty case
 * that is not empty — the exact v1 false-empty the paged contract exists to
 * close (`lexide-agent-bus-p6-spa-miniplan.md` §3, handoff §3.2).
 */

export type HistoryBodyState = "fallback" | "read-error" | "list";

export function historyBodyState(args: {
  messageCount: number;
  streamingBlockCount: number;
  hasError: boolean;
  hasFallback: boolean;
  historyReadError: string | null | undefined;
}): HistoryBodyState {
  const empty = args.messageCount === 0 && args.streamingBlockCount === 0;
  // The runtime-down fallback wins — it is the more specific diagnosis, and a
  // dead runtime fails the history read too.
  if (args.hasFallback && empty && !args.hasError) return "fallback";
  if (args.historyReadError && empty) return "read-error";
  return "list";
}
